module.exports = __webpack_public_path__ + "static/img/14000809.1f0ece7c.png";